<template>
  <div>
    <button
      v-if="canUserEdit"
      v-b-modal="'bulkDeleteRules' + uniqueIdentifier"
      v-b-tooltip.hover
      class="btn btn-danger mr-1"
      placement="bottom"
      title="Ausgewählte Regeln löschen"
      type="button"
      @click="ruleToEdit = 1"
    >
      <i class="fas fa-trash-alt" />
    </button>
    <b-modal
      v-if="ruleToEdit && canUserEdit"
      :id="'bulkDeleteRules' + uniqueIdentifier"
      :ref="'bulkDeleteRules' + uniqueIdentifier"
      :title="
        'Ausgewählte Regeln löschen (' + selectedRules.length + ' ausgewählt)'
      "
      hide-footer
      no-fade
    >
      <u-error-handling
        v-if="errorObject"
        :error-object="errorObject"
      />
      <u-loader v-if="isLoading" />
      <div v-else>
        <div class="ml-2 mb-4">
          Sind Sie sicher, dass Sie alle ausgewählten Regeln löschen möchten?
        </div>

        <b-button
          v-b-tooltip.hover
          class="ml-2"
          placement="bottom"
          title="Alle ausgewählten Regeln werden gelöscht"
          variant="success"
          @click="deleteRules()"
        >
          Ok
        </b-button>

        <b-button
          class="ml-2"
          variant="danger"
          @click="
            hideModal('bulkDeleteRules' + uniqueIdentifier);
            ruleToEdit = null;
          "
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { DeleteRules } from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  mixins: [MinimumWageMixin],
  props: {
    selectedRules: {
      type: Array,
      required: true,
    },
    uniqueIdentifier: {
      type: String,
      required: true,
    },
    editMode: {
      type: Boolean,
      default() {
        return true;
      },
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selected: [],
      isLoading: false,
      errorObject: null,
      ruleToEdit: null,
    };
  },
  methods: {
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    deleteRules() {
      this.errorObject = null;
      this.isLoading = true;
      var allRuleIds = [];

      this.selectedRules.map((rule) => {
        allRuleIds.push(rule.id);
      });

      DeleteRules(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        allRuleIds,
        () => {
          this.$emit("ruleSaved");
          this.hideModal("bulkDeleteRules" + this.uniqueIdentifier);
          this.ruleToEdit = null;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style>
.menuable__content__active {
  z-index: 6000 !important;
}
</style>

<style scoped>
.col-05 {
  -ms-flex: 0 0 2%;
  -webkit-box-flex: 0;
  flex: 0 0 2%;
  max-width: 2%;
}
</style>
